// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* .App {
  text-align: center;
} */

.App-logo {
  height: 40vmin;
  pointer-events: none;
}

@media (prefers-reduced-motion: no-preference) {
  .App-logo {
    animation: App-logo-spin infinite 20s linear;
  }
}

.App-header {
  background-color: #282c34;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  font-size: calc(10px + 2vmin);
  color:var(--themeFontColor);
}

.App-link {
  color: #61dafb;
}

@keyframes App-logo-spin {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}
.css-12k1obj-MuiFormLabel-root-MuiInputLabel-root,.MuiTypography-root,.css-14jccnq-MuiSvgIcon-root-MuiStepIcon-root.Mui-completed,.css-1l7z830-MuiPaper-root-MuiMenu-paper-MuiPopover-paper,.css-1klsplc-MuiStepLabel-label.Mui-completed,.css-1klsplc-MuiStepLabel-label,.css-17xv29d-MuiInputBase-root-MuiOutlinedInput-root-MuiSelect-root,.css-1klsplc-MuiStepLabel-label.Mui-active,.css-14jccnq-MuiSvgIcon-root-MuiStepIcon-root,.css-14jccnq-MuiSvgIcon-root-MuiStepIcon-root.Mui-active ,.css-1hps5ya-MuiFormLabel-root-MuiInputLabel-root {
  /* color: black !important; */
  color: var(--themeFontColor) !important;

  }
  .MuiTableCell-root{
    color: var(--tableHeadFontColor) !important;
  }
  .css-1klsplc-MuiStepLabel-label.Mui-completed,.css-1klsplc-MuiStepLabel-label.Mui-active{
    font-weight: 400!important;
  }
  .css-14jccnq-MuiSvgIcon-root-MuiStepIcon-root.Mui-active,.css-14jccnq-MuiSvgIcon-root-MuiStepIcon-root{
    color: rgba(0, 0, 0, 0.504) !important;
  }`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAAA;;GAEG;;AAEH;EACE,cAAc;EACd,oBAAoB;AACtB;;AAEA;EACE;IACE,4CAA4C;EAC9C;AACF;;AAEA;EACE,yBAAyB;EACzB,iBAAiB;EACjB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,6BAA6B;EAC7B,2BAA2B;AAC7B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE;IACE,uBAAuB;EACzB;EACA;IACE,yBAAyB;EAC3B;AACF;AACA;EACE,6BAA6B;EAC7B,uCAAuC;;EAEvC;EACA;IACE,2CAA2C;EAC7C;EACA;IACE,0BAA0B;EAC5B;EACA;IACE,sCAAsC;EACxC","sourcesContent":["/* .App {\r\n  text-align: center;\r\n} */\r\n\r\n.App-logo {\r\n  height: 40vmin;\r\n  pointer-events: none;\r\n}\r\n\r\n@media (prefers-reduced-motion: no-preference) {\r\n  .App-logo {\r\n    animation: App-logo-spin infinite 20s linear;\r\n  }\r\n}\r\n\r\n.App-header {\r\n  background-color: #282c34;\r\n  min-height: 100vh;\r\n  display: flex;\r\n  flex-direction: column;\r\n  align-items: center;\r\n  justify-content: center;\r\n  font-size: calc(10px + 2vmin);\r\n  color:var(--themeFontColor);\r\n}\r\n\r\n.App-link {\r\n  color: #61dafb;\r\n}\r\n\r\n@keyframes App-logo-spin {\r\n  from {\r\n    transform: rotate(0deg);\r\n  }\r\n  to {\r\n    transform: rotate(360deg);\r\n  }\r\n}\r\n.css-12k1obj-MuiFormLabel-root-MuiInputLabel-root,.MuiTypography-root,.css-14jccnq-MuiSvgIcon-root-MuiStepIcon-root.Mui-completed,.css-1l7z830-MuiPaper-root-MuiMenu-paper-MuiPopover-paper,.css-1klsplc-MuiStepLabel-label.Mui-completed,.css-1klsplc-MuiStepLabel-label,.css-17xv29d-MuiInputBase-root-MuiOutlinedInput-root-MuiSelect-root,.css-1klsplc-MuiStepLabel-label.Mui-active,.css-14jccnq-MuiSvgIcon-root-MuiStepIcon-root,.css-14jccnq-MuiSvgIcon-root-MuiStepIcon-root.Mui-active ,.css-1hps5ya-MuiFormLabel-root-MuiInputLabel-root {\r\n  /* color: black !important; */\r\n  color: var(--themeFontColor) !important;\r\n\r\n  }\r\n  .MuiTableCell-root{\r\n    color: var(--tableHeadFontColor) !important;\r\n  }\r\n  .css-1klsplc-MuiStepLabel-label.Mui-completed,.css-1klsplc-MuiStepLabel-label.Mui-active{\r\n    font-weight: 400!important;\r\n  }\r\n  .css-14jccnq-MuiSvgIcon-root-MuiStepIcon-root.Mui-active,.css-14jccnq-MuiSvgIcon-root-MuiStepIcon-root{\r\n    color: rgba(0, 0, 0, 0.504) !important;\r\n  }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
